import {
  DELETE_CURRENT_PRODUCT,
  SET_CONTACTS,
  SET_CURRENT_CONTACT,
  SET_CURRENT_PRODUCT,
  SET_CURRENT_VENDOR,
  SET_VENDORS,
  UPDATE_CONTACT,
  UPDATE_VENDOR,
  GET_SUBMITTED_PRODUCTS,
  GET_IN_REVIEW_PRODUCTS,
  GET_APPROVED_REJECTED_PRODUCTS,
  CLEAR_CURRENT_PRODUCT,
  UPDATE_CURRENT_PRODUCT,
  ADD_CURRENT_PRODUCT,
  REPLACE_CURRENT_PRODUCT,
  SET_SAVING,
} from 'context/types'

export default (state, action) => {
  switch (action.type) {
    case GET_SUBMITTED_PRODUCTS:
    case GET_IN_REVIEW_PRODUCTS:
    case GET_APPROVED_REJECTED_PRODUCTS:
      return {
        ...state,
        products: action.payload,
      }
    case DELETE_CURRENT_PRODUCT:
      return {
        ...state,
        products: state.products.filter(
          product => product.oldUPC !== action.payload
        ),
      }
    case SET_CURRENT_PRODUCT:
      return {
        ...state,
        current: state.products.find(product => product.UPC === action.payload),
      }
    case SET_CURRENT_CONTACT:
      return {
        ...state,
        contact: state.contacts.find(
          contact => contact.pkContact === action.payload
        ),
      }
    case SET_CURRENT_VENDOR:
      return {
        ...state,
        vendor: state.vendors.find(vendor => vendor.id === action.payload),
      }
    case SET_CONTACTS:
      return {
        ...state,
        contacts: action.payload,
      }
    case SET_VENDORS:
      return {
        ...state,
        vendors: action.payload,
      }
    case UPDATE_CONTACT:
      return {
        ...state,
        contacts: state.contacts.map(contact =>
          contact.pkContact === action.payload.pkContact
            ? action.payload
            : contact
        ),
      }
    case UPDATE_VENDOR:
      return {
        ...state,
        vendors: state.vendors.map(vendor =>
          vendor.pkVendor === action.payload.pkVendor ? action.payload : vendor
        ),
      }
    case CLEAR_CURRENT_PRODUCT:
      return {
        ...state,
        current: null,
      }
    case UPDATE_CURRENT_PRODUCT:
      return {
        ...state,
        products: state.products.filter(
          product => product.UPC !== action.payload.UPC
        ),
        current: null,
      }
    case ADD_CURRENT_PRODUCT:
      return {
        ...state,
        products: [action.payload, ...state.products],
        current: null,
      }
    case REPLACE_CURRENT_PRODUCT:
      return {
        ...state,
        products: [action.payload, ...state.products],
        current: null,
      }
    case SET_SAVING:
      return {
        ...state,
        saving: action.payload,
      }
    default:
      return state
  }
}
